import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { usePermissions } from '../context/PermissionsContext';
import { useTheme } from '../context/ThemeContext';
import SegmentedControl from '../components/SegmentedControl';
import { EMPTY } from '../utils/format';

const THEME_OPTIONS = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

/** Your own admin account: who you are signed in as, what you can do, and your theme. */
const Profile = () => {
  const { instance, accounts } = useMsal();
  const { role, loading, error, reload } = usePermissions();
  const { theme, toggleTheme } = useTheme();
  const account = accounts[0];

  const handleSignOut = () => {
    // The popup ends on the redirect bridge (postLogoutRedirectUri in index.jsx), which closes it
    instance.logoutPopup().catch((err) => console.error('Sign out failed:', err));
  };

  let access;
  if (loading) {
    access = <span className="text-muted">Checking...</span>;
  } else if (role === 'ADMIN') {
    access = 'Admin: can change settings';
  } else if (role === 'VIEWER') {
    access = 'View only';
  } else {
    access = (
      <span className="text-muted">
        {error ? 'Could not be checked.' : 'Unknown.'}{' '}
        <Button variant="link" size="sm" className="p-0 align-baseline" onClick={reload}>Try again</Button>
      </span>
    );
  }

  return (
    <Container fluid className="py-4">
      <h1 className="mb-4">Profile</h1>

      <Row>
        <Col lg={8} xl={6}>
          <Card className="shadow-sm">
            <Card.Header className="bg-light">
              <h5 className="mb-0">Your account</h5>
            </Card.Header>
            <Card.Body>
              <dl className="kv-list mb-4">
                <dt>Name</dt>
                <dd>{account?.name || EMPTY}</dd>
                <dt>Email</dt>
                <dd>{account?.username || EMPTY}</dd>
                <dt>Access</dt>
                <dd>{access}</dd>
                <dt>Theme</dt>
                <dd>
                  <SegmentedControl
                    options={THEME_OPTIONS}
                    value={theme}
                    onChange={(value) => { if (value !== theme) toggleTheme(); }}
                    ariaLabel="Theme"
                  />
                </dd>
              </dl>
              <Button variant="outline-secondary" onClick={handleSignOut}>Sign out</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
